/**
 * If the value is an array, return the last element or `undefined` if the array is empty. Otherwise, returns the value.
 */
export function getLastElement(value) {
    if (!Array.isArray(value)) {
        return value;
    }
    else if (value.length === 0) {
        return undefined;
    }
    else {
        return value[value.length - 1];
    }
}
//# sourceMappingURL=get-last-element.js.map